import { SummarizerConfig } from '../../types/summarizer';

export const powerpointSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'powerpoint-summarizer',
  title: 'PowerPoint Presentation Summarizer',
  description: 'Summarize PowerPoint presentations and extract key insights from slides',
  version: '1.0.0',

  // Categorization
  category: 'document',
  tags: ['powerpoint', 'presentation', 'slides', 'pptx', 'business'],

  // Input configuration
  inputs: {
    file: {
      enabled: true,
      acceptedTypes: ['.pptx', '.ppt', '.odp'],
      maxSize: 100 * 1024 * 1024, // 100MB in bytes
      placeholder: 'Upload PowerPoint presentation',
      multiple: false,
      helpText:
        'Supports PowerPoint files up to 100MB or online presentation links from Microsoft 365 and Google Slides.',
      showHelpText: true,
    },
    url: {
      enabled: true,
      placeholder: 'Enter PowerPoint online link',
      // validation: /powerpoint\.live\.com|sharepoint\.com.*\.pptx|drive\.google\.com.*\/presentation/,
      examples: [
        'https://1drv.ms/p/s!...',
        'https://company.sharepoint.com/.../presentation.pptx',
        'https://docs.google.com/presentation/d/...',
      ],
      showExamples: true,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: true,
    download: true,
    share: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'powerpoint',
    timeout: 120000, // 2 minutes for presentation processing
  },

  // UI customization (Level 2: Custom styling)
  ui: {
    // Basic styling
    primaryColor: '#d24726', // PowerPoint orange
    secondaryColor: '#c73e1d',
    icon: '📊',

    // Custom styles (Level 2)
    customStyles: {
      container: '',
      inputArea: 'bg-white shadow-lg rounded-lg border-2 border-orange-100',
      button:
        'bg-orange-600 hover:bg-orange-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-200',
    },

    theme: 'light',
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 10 * 1024, // 10KB minimum
    maxSize: 100 * 1024 * 1024, // 100MB in bytes
    allowedDomains: [
      'powerpoint.live.com',
      'sharepoint.com',
      'onedrive.live.com',
      'docs.google.com',
    ],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
